import { actionCreatorFactory } from "typescript-fsa";
import { FavouriteUrl } from "core/types/favourite-url.types";

const actionCreator = actionCreatorFactory("favourite_url");

export const resetFavouriteUrl = actionCreator<void>("RESET");

export const favouriteUrl = actionCreator<{ favouriteUrl: FavouriteUrl }>(
  "FAVOURITE_URL"
);

export const isFavouriteUrlLoading = actionCreator<{
  isFavouriteUrlLoading: boolean;
}>("IS_FAVOURITE_URL_LOADING");

export const favouriteUrlList = actionCreator<{
  favouriteUrlList: FavouriteUrl[];
}>("FAVOURITE_URL_LIST");

export const favouriteUrlSuccess = actionCreator<{
  favouriteUrlSuccess: string;
}>("FAVOURITE_URL_SUCCESS");
